import { Filter } from '@bingads-webui/listener';

export class UnloadLogFilter extends Filter {
  check(log) {
    return !(log.activityName === 'RunAriaV2UnloadHandler' &&
            log.scenarioName === 'PageUnload' &&
            !log.excludeFromLocalStorage);
  }
}
